import { useTranslation } from "react-i18next";
import ContactUs from "../Other/smikrecruit/ContactUs";
import { useState } from "react";
import Modal from "../Other/Modal";

export default function GuaranteedHero() {
  const { t } = useTranslation();
   const [isModalOpen, setIsModalOpen] = useState(false);
  
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
  return (
    <div className="relative pt-16">
      {/* Background Image */}
      <div
        className="!absolute inset-0 z-0"
        style={{
          backgroundImage: "url(/image/reception.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="!absolute inset-0 bg-black/40" /> {/* Overlay */}
      </div>

      <div className="relative z-10 flex flex-col items-start justify-center h-full">
        <div className="max-w-7xl mx-auto w-full pt-24 pb-16">
          <h1 className="text-4xl sm:text-2xl md:text-2xl font-bold text-white mb-4">
            Guaranteed-To-Run Live Classes
          </h1>
          <h2 className="text-4xl sm:text-2xl md:text-2xl font-bold text-white mb-4">Nominate your teams today!</h2>
          <button className="bg-blue-800/90 inline-block px-8 py-4 rounded-tr-lg rounded-br-lg" onClick={openModal}>
            <h1 className="text-4xl sm:text-2xl md:text-2xl font-bold text-white">
              Contact Us
            </h1>
          </button>
        </div>
      </div>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <div className="flex items-center justify-content-between bg-[#0e63e2] rounded-md mb-2 py-3">
            <p className="text-white font-bold text-xl pl-3">Contact Us</p>
          </div>
          <div className="bg-white w-[100%] h-[88%] rounded-lg shadow-lg relative overflow-auto">
            <ContactUs />
          </div>
        </Modal>
      )}
    </div>
  );
}
